module.exports = __webpack_public_path__ + "static/media/process_2.e922d7ae.png";